import { Breakpoints } from '../providers/BreakpointProvider';

export type MapVisibilityInitParams = {
  breakpoint: number;
  isMapToggledOnCookie: string | undefined;
  isMapToggledOnInitially: boolean | undefined;
  shouldReturnToMapView: boolean;
};

/**
 * Computes the initial map visibility state based on device, user preferences, and navigation context.
 *
 * Priority order:
 * 1. Session storage (user navigating back from expose) - ALL devices
 * 2. Mobile: always false
 * 3. Desktop: cookie > prop > false
 */
export const computeInitialMapState = (params: MapVisibilityInitParams): boolean => {
  const { breakpoint, isMapToggledOnCookie, isMapToggledOnInitially, shouldReturnToMapView } = params;

  // Priority 1: Session storage (navigation flow - all devices)
  if (shouldReturnToMapView) {
    return true;
  }

  // Priority 2: Apply device-specific defaults
  const isDesktop = breakpoint >= Breakpoints.TABLET_LANDSCAPE;

  if (!isDesktop) {
    // Mobile: always default to closed (map is not shown on load)
    return false;
  }

  // Desktop: use cookie preference if available, otherwise use prop default
  if (isMapToggledOnCookie !== undefined) {
    return isMapToggledOnCookie === 'true';
  }

  return isMapToggledOnInitially ?? false;
};

export const shouldPersistToCookie = (breakpoint: number | undefined): boolean => {
  if (breakpoint === undefined) return false;
  return breakpoint >= Breakpoints.TABLET_LANDSCAPE;
};
